package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class EventResponse(
    @SerialName("school_id") val schoolId: String? = null,
    val title: String? = null,
    val description: String? = null,
    @SerialName("event_date") val eventDate: String? = null,
    @SerialName("event_id") val eventId: String? = null,
    val audience: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    val status: String? = null,
    val id: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String>? = null,
    @SerialName("attachment_file_urls") val attachmentFileUrls: List<String>? = null
)

@Serializable
data class TeacherEventStatisticsResponse(
    @SerialName("teacher_id") val teacherId: String? = null,
    @SerialName("teacher_name") val teacherName: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("academic_year_label") val academicYearLabel: String? = null,
    @SerialName("academic_year_start") val academicYearStart: String? = null,
    @SerialName("academic_year_end") val academicYearEnd: String? = null,
    val counters: Map<String, Int> = emptyMap()
)
